import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalInitService } from '../services/init/global-init.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalInitGuard implements CanActivate {
  constructor(private router: Router, private globalInitService: GlobalInitService) {}

  canActivate(): Observable<boolean> {
    return from(this.globalInitService.init()).pipe(
      map(isOK => {
        if (!isOK) {
          this.router.navigate(['/500']);
          return false;
        }
        return true;
      })
    );
  }
}
